import { render, staticRenderFns } from "./NakedApproval.vue?vue&type=template&id=dc365ad0&scoped=true"
import script from "./NakedApproval.vue?vue&type=script&lang=js"
export * from "./NakedApproval.vue?vue&type=script&lang=js"
import style0 from "./NakedApproval.vue?vue&type=style&index=0&id=dc365ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc365ad0",
  null
  
)

export default component.exports